import { useEffect, useRef } from 'react';
import { useMixpanel } from '../MixpanelProvider';

export const useTrackScreenView = (screenName: string) => {
    const isFirstRender = useRef(false);
    const { track } = useMixpanel();

    useEffect(() => {
        if (isFirstRender.current) return;
        isFirstRender.current = true;
        track(screenName);
    }, [screenName, track]);
};
